import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-4 px-4 flex-shrink-0">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-center items-center gap-4">
        <div className="text-sm text-text text-center">
          © {currentYear}{' '}
          <a
            href="https://matchadesign.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium hover:text-primary transition-colors"
          >
            Matcha Design
          </a>
          . All rights reserved.
        </div>
      </div>
      <div className="max-w-4xl mx-auto mt-2 text-xs text-center text-muted">
        <p className="text-[11px]">
          Emoji Alchemist matches your words and phrases to emoji. Voice input is handled by your
          browser’s speech service. Results vary with wording and generation style. This tool is
          intended for entertainment and educational purposes only.
        </p>
      </div>
    </footer>
  );
};

export default Footer;